// removed by extract-text-webpack-plugin
module.exports = {"new_right_wx":"_2zwS1bfGNf6UHPTqh8Kq2P"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NewMediumGzh/NewMediumGzh.scss
 ** module id = 1078
 ** module chunks = 0
 **/